import { AxiosError, type AxiosRequestConfig } from 'axios';
import axiosInstance from 'Config/axios/axios-config';
import type { FetchResponseI } from 'types';

interface FetchDataOptions extends AxiosRequestConfig {
  /**
   * Si es true, incluye los campos meta y jsonapi de la respuesta JSON:API
   */
  includeJsonApiMeta?: boolean;
  /**
   * Si es true, incluye el campo pagination de la respuesta paginada
   */
  includePagination?: boolean;
}

export async function fetchData<T>(url: string, options: FetchDataOptions = {}): Promise<FetchResponseI<T>> {
  const { includeJsonApiMeta, includePagination, ...axiosOptions } = options;

  try {
    const response = await axiosInstance({
      url,
      ...axiosOptions,
      headers: {
        ...axiosOptions.headers,
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (axiosOptions.responseType === 'blob') {
      return {
        data: response.data,
        error: null,
      };
    }

    const result: FetchResponseI<T> = {
      data: response.data?.data,
      error: null,
    };

    if (includeJsonApiMeta) {
      result.meta = response.data?.meta ?? null;
      result.jsonapi = response.data?.jsonapi ?? null;
    }

    if (includePagination) {
      result.pagination = response.data?.pagination ?? null;
    }

    return result;
  } catch (error) {
    const response: FetchResponseI<null> = {
      data: null,
      error: 'Ocurrio un problema, intentalo nuevamente',
    };

    if (error instanceof AxiosError) {
      response.error = error.response?.data?.error;
      response.code = error.response?.data?.code ?? null;
    } else if (error instanceof Error) {
      response.error = error.message;
    }

    return response;
  }
}
